import { Colors } from '@vetahealth/fishing-gear/colors'
import {
  convert,
  defaultUnits,
  getDisplayValue,
  normalize,
  normalizedUnitRanges,
  normalizedUnits,
} from '@vetahealth/fishing-gear/conversions'
import { CardDetails } from '@vetahealth/tuna-can-api'
import i18next from 'i18next'

import { LineChart } from '../Chart/LineChart'
import { createAlertField, createDeviceField } from '../Table/helpers'
import { GetResultsConfigParams, ResultsConfig } from './types'

export function getHbA1cConfig({ userUnits }: GetResultsConfigParams): ResultsConfig {
  const unit = userUnits.hbA1c || defaultUnits.hbA1c

  const [min, max] = normalizedUnitRanges.hbA1c
  const [convertedMin] = convert(min, normalizedUnits.hbA1c, 'hbA1c', unit)
  const [convertedMax] = convert(max, normalizedUnits.hbA1c, 'hbA1c', unit)

  return {
    key: 'hbA1c',
    title: i18next.t('tracking.hbA1c.title'),
    category: 'tracking',
    unit,
    format: (event, targetUnit, omitUnit) =>
      event.value !== undefined
        ? getDisplayValue([event.value, event.additionalValue ?? 0], event.unit ?? normalizedUnits.hbA1c, 'hbA1c', {
            targetUnit,
            omitUnit,
          })
        : '–',
    actions: {
      add: [
        {
          key: 'value',
          label: i18next.t('tracking.hbA1c.hbA1c', { unit }),
          validators: [
            { required: true, message: i18next.t('validations.enterHbA1c') },
            {
              min,
              max,
              type: 'number',
              transform: (value) => normalize('hbA1c', Number(value), unit)[0],
              message: i18next.t('validations.trackingRange', {
                min: convertedMin,
                max: convertedMax,
                unit,
              }),
            },
          ],
        },
      ],
      reviewBulk: true,
      downloadCsv: true,
    },
    chart: {
      component: LineChart,
      intervals: ['day', 'week', 'month', 'trend'],
      dataKeys: [{ key: 'value', color: Colors.azure500 }],
      getData: (data: CardDetails[]) =>
        data.map((event) => ({
          ...event,
          value: convert(event.value, event.unit, 'hbA1c', unit)[0],
        })),
    },
    table: {
      defaultFields: true,
      additionalFields: [createAlertField(), createDeviceField()],
      actions: ['review', 'delete'],
    },
  }
}
